import { Typography } from "@/components/text";

const ViewOnlyRemark = () => {
	return (
		<div className="w-full bg-white px-4 md:px-12 py-2">
			<Typography fontWeight={400} fontSize={14} align="center">
				You have view-only access as an external member. Editing or making
				changes to this case is restricted.
			</Typography>
		</div>
	);
};

export default ViewOnlyRemark;
